import { render, staticRenderFns } from "./orderPrinting.vue?vue&type=template&id=506ade87&scoped=true&"
import script from "./orderPrinting.vue?vue&type=script&lang=js&"
export * from "./orderPrinting.vue?vue&type=script&lang=js&"
import style0 from "./orderPrinting.vue?vue&type=style&index=0&id=506ade87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ade87",
  null
  
)

export default component.exports